import * as firebase from 'firebase';
import { Observable } from 'rxjs/Rx';
import * as RxFirebase from 'rx-firebase';

RxFirebase.extend(firebase, Observable);

const config = {
  apiKey: 'AIzaSyBtvFRNEYR2hKF4yhPNQtLdngKRFn4dMT4',
  authDomain: 'wilshire-grand.firebaseapp.com',
  databaseURL: 'https://wilshire-grand.firebaseio.com',
  storageBucket: 'wilshire-grand.appspot.com',
  messagingSenderId: '561309455292'
};

firebase.initializeApp(config);

export const auth = firebase.auth();
export const database = firebase.database();
export const storage = firebase.storage();



// WEBPACK FOOTER //
// ./src/firebase-app.js